import logFactory from 'c9-js-log-client';
import { createLoggingAndTrackingMiddleware } from 'flos-react-cvi';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import ReduxThunk from 'redux-thunk';
import { rootReducer } from './root.reducer';

export function configureStore(config) {
    const store = createStore(
        rootReducer,
        composeWithDevTools(
            applyMiddleware(
                ReduxThunk,
                createLoggingAndTrackingMiddleware({
                    logger: logFactory(config.endpoints.log, config.appId, config.logLevel),
                    tracker: config.trackingHandler
                })
            )
        )
    );

    /* istanbul ignore next */
    if (process.env.NODE_ENV !== 'production') {
        if (module.hot) {
            module.hot.accept('./root.reducer', () => {
                const nextRootReducer = require('./root.reducer').rootReducer;
                store.replaceReducer(nextRootReducer);
            });
        }
    }

    return store;
}
